import routes from "@/routes/routes";
import type { RouteConfig } from "@/types/routestypes";

export const getPageTitle = (pathname: string) => {
  const removeLastEndpoint = (str: string) => str.split("/").slice(0, -1).join("/");

  const flatRoutes: RouteConfig[] = Object.values(routes.privateRoutes).flatMap((route) => {
    if (!route.children) return [route];

    const children: RouteConfig[] = Array.isArray(route.children)
      ? route.children
      : Object.values(route.children);

    return children.map((child) => ({ ...child, path: `${route.path}/${child.path}` }));
  });

  const route = flatRoutes.find(
    (candidate) =>
      candidate.path === pathname ||
      (candidate.path.endsWith("Id") &&
        removeLastEndpoint(candidate.path) === removeLastEndpoint(pathname)),
  );

  return route?.pageName || "";
};
